import axios from "axios";

// Create Axios instance
// "https://webapi.tdcp.gop.pk"
// "http://localhost:5000"

const tdcpMainSiteApi = axios.create({
  baseURL: "https://webapi.tdcp.gop.pk",
  headers: {
    "Content-Type": "application/json",
  },
});

// Attach token from sessionStorage before each request
tdcpMainSiteApi.interceptors.request.use(
  (config) => {
    const userDetails = sessionStorage.getItem("userDetails");

    if (userDetails) {
      try {
        const { token } = JSON.parse(userDetails);
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      } catch (err) {
        console.warn("Invalid userDetails in sessionStorage:", err);
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Handle global errors (optional)
tdcpMainSiteApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn("Unauthorized — invalid or expired token");
      // Optionally: redirect to login or clear session
      // sessionStorage.clear();
      // window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default tdcpMainSiteApi;
